// src/api/noticeApi.js

import axios from "axios";

// 나중에 서버 DB에서 내려줄 데이터라고 가정합니다.
const TOTAL_MOCK_DATA = Array.from({ length: 12 }).map((_, i) => ({
  id: i + 1,
  title: `2019년 송년의 밤 ${i + 1}`,
  desc: "2019년 송년의 밤",
  date: `2026.10.${String(30 - i).padStart(2, "0")}`,
  imgUrl: `/images/송년의밤1.jpeg`,
  gallery: [
    `/images/송년의밤1.jpeg`,
    "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80",
  ],
}));

export const getNotices = async (page = 1, limit = 4) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACK_API_URL}/API/HomePage/Notice/getNotices`,
      {
        params: {
          page: page,
          limit: limit,
        },
      },
    );
    console.log(response);
    if (response.status === 200) {
      return response.data.data;
    } else {
      return { data: [], hasMore: false };
    }
  } catch (error) {
    console.error("API 호출 중 에러 발생:", error);

    throw error;
  }
};
